import './EnrollmentStatusEditor.less';
import React, {useState, useEffect} from 'react';
import __ from "../../i18n";
import CustomForm from "../../../bootstrap/components/custom-form/CustomForm";
import {LabelMap} from "../../../bootstrap/types";
import Request from "../../../bootstrap/api/Request";
import Toasts, {TOAST_SUCCESS} from "../../../bootstrap/scomponents/toasts/Toasts";
import EnrollmentUpdateParcel from "../../api/endpoints/enrollment/EnrollmentUpdateParcel";
import statuses from "../../model-constants/enrollment/statuses";
import EnrollmentStatusView from "../../widgets/enrollment-status-view/EnrollmentStatusView";



export default function EnrollmentStatusEditor({recordId = null, defaultValues = {}, onDone, onSubmittingChange, onCancel}) {

    const fieldsConfig = {
        status: {
            name: __('Status'),
            type: 'singleSelect',
            defaultValue: defaultValues.status,
            data: {
                options: new LabelMap(statuses.items.map(item => ([
                    item.value,
                    <EnrollmentStatusView value={item.value} showsLabel={true}/>
                ])))
            },
            rules: {
                required: true
            }
        }
    };

    const layoutConfig = [
        'status',
    ];

    const submit = (values, onSuccess, onError) => {

        Request.add(new EnrollmentUpdateParcel(recordId, values))
            .then((data) => {
                Toasts.add(TOAST_SUCCESS, __('Your changes have been saved successfully'));
                onSuccess();
                onDone(values);
            })
            .catch(error => {
                onError(error.getMessage());
            });
    };

    const cancel = () => {
        onCancel();
    };

    return <div className="enrollment-status-editor">
        <CustomForm
            fieldsConfig={fieldsConfig}
            layoutConfig={layoutConfig}
            submitChanges={submit}
            cancel={cancel}
            submitText={__('Save changes')}
            onSubmittingChange={onSubmittingChange}
        />
    </div>;
}
